import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    eventId: null,
    event: null,
    isLoading: false,
};
export const MatchesSlice = createSlice({
    name: 'matches',
    initialState,
    reducers: {
        setEventId: (state, action) => {
            // eslint-disable-next-line no-param-reassign
            state.eventId = action.payload;
        },
        setEvent: (state, action) => {
            // eslint-disable-next-line no-param-reassign
            state.event = action.payload;
        },
        setMatchesIsLoading: (state, action) => {
            // eslint-disable-next-line no-param-reassign
            state.isLoading = action.payload;
        },
    },
});
export default MatchesSlice.reducer;
export const { setEventId, setEvent, setMatchesIsLoading } = MatchesSlice.actions;
export const selectMatchesIsLoading = (state) => state.matches.isLoading;
export const selectEventId = (state) => state.matches.eventId;
export const selectEvent = (state) => state.matches.event;
